// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingComponent__loadingDiv__SmGop{display:flex;flex:1 0 auto;align-items:center;justify-content:center}
`, "",{"version":3,"sources":["webpack://./src/js/apps/common/permissions/components/LoadingComponent.scss"],"names":[],"mappings":"AAAA,qCACI,YAAa,CACb,aAAc,CACd,kBAAmB,CACnB,sBAAuB","sourcesContent":[".loadingDiv {\n    display: flex;\n    flex: 1 0 auto;\n    align-items: center;\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingDiv": `LoadingComponent__loadingDiv__SmGop`
};
export default ___CSS_LOADER_EXPORT___;
